import { ForkEffect, takeEvery, CallEffect, TakeEffect, race, delay, take, call, put } from '@redux-saga/core/effects';
import { AxiosResponse } from 'axios';
import { serverAxios } from 'app/utils/axios';
import { IRefreshTokenResponse } from 'app/models/response';
import { LocalStorage } from 'app/constants/StorageConstants';

import * as authAction from '../actions/auth';

function* loginSaga() {
  let loggeIn: boolean = yield true;

  while (loggeIn) {
    const [delayAction, logoutAction]: [CallEffect, TakeEffect] = yield race<CallEffect | TakeEffect>([
      delay(60 * 1000),
      take(authAction.AUTH_LOGIN),
    ]);

    if (delayAction) {
      try {
        yield call(async () => {
          return serverAxios
            .post('/', {
              act: 'refreshtoken',
              token: localStorage.getItem(LocalStorage.Token),
            })
            .then((response: AxiosResponse<IRefreshTokenResponse>) => {
              if (response.status !== 200 || response.data.error) {
                throw response.data.error;
              }

              localStorage.setItem(LocalStorage.Token, response.data.token);
            });
        });
      } catch {
        loggeIn = yield false;
      }

      if (!loggeIn) {
        yield put(authAction.logout());
      }
    }

    if (logoutAction) {
      loggeIn = yield false;
    }
  }
}

function* logoutSaga() {
  yield localStorage.removeItem(LocalStorage.Token);
}

function* autoLoginSaga() {
  const token: string | null = localStorage.getItem(LocalStorage.Token);

  try {
    const response: AxiosResponse<IRefreshTokenResponse> = yield serverAxios.post('/', {
      act: 'refreshtoken',
      token,
    });

    if (!response.data.error) {
      yield put(authAction.login({ ...response.data.user }));
    }
  } catch {
    console.error('auto login failed');
  }
}

export function* watchAuth(): IterableIterator<ForkEffect> {
  yield takeEvery(authAction.AUTH_LOGIN, loginSaga);
  yield takeEvery(authAction.AUTH_LOGOUT, logoutSaga);
  yield takeEvery(authAction.AUTH_AUTO_LOGIN, autoLoginSaga);
}
